export default "/images/vendor/flag-icon-css/flags/1x1/gi.svg?89adf2b0737e6987f658c9b0170d3837";